import { Component, OnInit, Input } from '@angular/core';
import { SasisopaService } from '../../../../services/sasisopa.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'ngx-operation-controls',
  templateUrl: './operation-controls.component.html',
  styleUrls: ['./operation-controls.component.scss']
})
export class OperationControlsComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: any;
  loading = false;
  employees = [];
  files: any = [];
  data: any = {
    personal: {},
    implementation: {},
  };
  today = new Date();
  year = moment(this.today).format('YYYY')

  constructor(
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<OperationControlsComponent>,
  ) { }

  async ngOnInit() {
    this.loading = true
    if (this.action === 'edit') {
      this.stationId = this.infoEdit.station_id
    }
    await this.checkIfCreateOrEdit()
    this.loading = false
  }

  async store() {
    this.data.station_id = this.stationId
    console.log(this.data.datetime);
    this.loading = true;
    const [error, response] = await this.sasisopaService.createProcesses(this.data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Formato creado con éxito', 'success');
    this.ref.close(true);
  }

  async editFormat() {
    this.loading = true
    const [error, response] = await this.sasisopaService.editProcesses(this.infoEdit.id, this.data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false
    await this.alert('Formato editado con éxito', 'success');
    this.ref.close(true);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') {
      this.data.station_id = this.infoEdit.station_id
      this.data.name = this.infoEdit.name
      this.data.activities = this.infoEdit.activities
      this.data.personal = this.infoEdit.personal
      this.data.development_stage = this.infoEdit.development_stage
      this.data.environmental_aspect = this.infoEdit.environmental_aspect
      this.data.risk = this.infoEdit.risk
      this.data.operation_criteria = this.infoEdit.operation_criteria
      this.data.implementation = this.infoEdit.implementation
      this.data.description = this.infoEdit.description
    }
  }

}
